import { render, staticRenderFns } from "./sixButton.vue?vue&type=template&id=fb5321b2&scoped=true&"
import script from "./sixButton.vue?vue&type=script&lang=js&"
export * from "./sixButton.vue?vue&type=script&lang=js&"
import style0 from "./sixButton.vue?vue&type=style&index=0&id=fb5321b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb5321b2",
  null
  
)

export default component.exports